import React from "react";

import type { AdaptiveRecommendationReason } from "@/lib/wearables/wearablesAdaptiveEngine";
import type { WearablesContext } from "@/lib/wearables/wearablesContextEngine";
import type { WearablesRouteSurface } from "@/lib/wearables/wearables.routeCompanion";

import "./wearables-v2.css";

type Props = {
  title: string;
  body: string;
  chips: string[];
  destinationSurface: WearablesRouteSurface;
  destinationLabel: string;
  adaptiveReason: AdaptiveRecommendationReason;
  confidence: number;
  signalTrack: string;
  context: WearablesContext;
  onAccept: () => void;
  onRevise: () => void;
  onDismiss: () => void;
};

export default function WearablesMiniOverlay({
  title,
  body,
  chips,
  destinationSurface,
  destinationLabel,
  onAccept,
  onRevise,
  onDismiss,
}: Props): JSX.Element {
  const summaryBody = summarizeBody(body);

  return (
    <aside className="st-wearables-v2-overlay">
      <div>
        <p className="st-wearables-v2__eyebrow">Readiness Compass</p>
        <h2 className="st-wearables-v2__title">{title}</h2>
        <p className="st-wearables-v2__body">{summaryBody}</p>
      </div>

      <div className="st-wearables-v2__chips">
        {chips.slice(0, 4).map((chip) => (
          <span key={chip} className="st-wearables-v2__chip">
            {chip}
          </span>
        ))}
      </div>

      <div className="st-wearables-v2__overlay-actions">
        <button
          type="button"
          className="st-wearables-v2__button st-wearables-v2__button--primary"
          onClick={onAccept}
        >
          {destinationSurface === "omnistudio"
            ? "Continue with creator flow"
            : destinationSurface === "xr"
              ? "Continue with XR flow"
              : `Continue with ${destinationLabel}`}
        </button>
        <button type="button" className="st-wearables-v2__button" onClick={onRevise}>
          Wearables Hub
        </button>
        <button type="button" className="st-wearables-v2__button" onClick={onDismiss}>
          Dismiss
        </button>
      </div>
    </aside>
  );
}

function summarizeBody(body: string): string {
  const normalized = body.replace(/\s+/g, " ").trim();
  const match = normalized.match(/^.*?[.!?](?:\s|$)/);
  return match ? match[0].trim() : normalized;
}